import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { isLightTheme } from 'uiKit/Theme/themeUtils';

const name = 'AccountMenuButton';

export const useAccountMenuButtonStyles = makeStyles<boolean>({ name })(
  (theme, isOpen) => ({
    root: {
      padding: 0,
      minWidth: 'unset',
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.text.primary,
      backgroundColor: isOpen
        ? theme.palette.grey[200]
        : theme.palette.background.paper,

      boxShadow: isOpen
        ? `0 0 0 3px ${alpha(theme.palette.primary.main, 0.5)}`
        : undefined,

      '&:hover': {
        backgroundColor: theme.palette.grey[200],

        color: isLightTheme(theme) ? undefined : theme.palette.common.white,
      },

      '&&': {
        [theme.breakpoints.down('xs')]: {
          gap: 2,
          padding: theme.spacing(1, 2),
        },
      },
    },
    endIcon: {
      '&&&': {
        marginLeft: theme.spacing(1),

        color: theme.palette.text.secondary,

        svg: {
          [theme.breakpoints.down('xs')]: {
            width: 20,
            height: 20,
          },
        },
      },
    },
    groupName: {
      marginLeft: theme.spacing(2),
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      maxWidth: '150px',
      overflow: 'hidden',

      [theme.breakpoints.down('sm')]: {
        maxWidth: '100px',
      },

      [theme.breakpoints.down('xs')]: {
        maxWidth: '50px',
        display: 'none',
      },
    },
  }),
);
